module.exports = {
    status: {
        Processing: "processing",
        Ready: "ready",
        Error: "error",
        Deleted: "deleted"
    }
};